<template lang="html">
  <div :tabindex="tabIndex" @click="clicked" @keypress="clicked" class="icon-container" :class="{'hovered': hover || active}">
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h48v48H0z"/>
        <path fill="#000" d="M38 12.82L35.18 10 24 21.18 12.82 10 10 12.82 21.18 24 10 35.18 12.82 38 24 26.82 35.18 38 38 35.18 26.82 24z"/>
      </g>
    </svg>
  </div>
</template>

<script>
  export default {
    props: {
      tabIndex: {
        required: false,
        type: Number,
        default: 0,
      },
      active: {},
      hasHoverState: {},
    },
    data() {
      return {
        hover: false,
      };
    },
    methods: {
      entered() {
        if (this.hasHoverState) {
          this.hover = true;
          this.$emit('entered');
        }
      },
      left() {
        this.hover = false;
        this.$emit('left');
      },
      clicked() {
        this.$emit('clicked');
      },
    },
  };
</script>

<style lang="scss" scoped>

  $primary-accent-color: #50e3c2;

  .icon {
    cursor: pointer;
    height: 40px;
    width: 40px;
  }

  .icon-container {
    border-radius: 20px;
    height: 48px;
    width: 48px;
    display: inline-block;
    z-index: 9999;
  }

  .hovered {
    background-color: $primary-accent-color;
  }

</style>



// WEBPACK FOOTER //
// src/lib/rare-patternlab/src/components/icons/navigation/RareModalCloseIconLargeBlack.vue